import { logger } from '@/utils';
import { type MessageArgsProps, message } from 'antd';
import {
  type FC,
  type PropsWithChildren,
  type ReactNode,
  createContext,
  useContext,
} from 'react';

const Context = createContext<{
  openMessage: (
    type: MessageArgsProps['type'],
    message: ReactNode,
  ) => PromiseLike<void>;
} | null>(null);

const _useContext = () => {
  const context = useContext(Context);
  if (!context) {
    throw new Error('useMessage must be used within MessageProvider.');
  }
  return context;
};

export const useMessage = () => {
  return _useContext();
};

export const MessageProvider: FC<PropsWithChildren> = ({ children }) => {
  const [messageApi, contextHolder] = message.useMessage({ maxCount: 1 });

  return (
    <Context.Provider
      value={{
        openMessage: async (type, message) => {
          await messageApi
            .open({
              type,
              content: <div data-dd-privacy="allow">{message}</div>,
            })
            .then(undefined, (e) => logger.error('failed to open message', e));
        },
      }}
    >
      {contextHolder}
      {children}
    </Context.Provider>
  );
};
